import React from "react";
import AppHeadsup from "../app-headsup/app-headsup";
import AppChatHeaderClients from "../app-chat-header-clients/app-chat-header-clients";
import { AppChatMessages } from "../app-chat-messages/app-chat-messages";
import AppChatFileUploads from "../app-chat-file-uploads/app-chat-file-uploads";
import PropTypes from "prop-types";
import _ from "lodash";
import "./app-chat.css";
import appState from "../../state/AppStateContainer";
import moment from "moment";
import { ServiceProjects } from "../../services/service-projects";
import appEnum, { FileScope } from "../../util/appEnum";
moment.locale("sv");
import styles from "./app-chat.module.scss";
import BtGrid from "../bt-grid/bt-grid";
import BtRow from "../bt-row/bt-row";
import BtColumn from "../bt-column/bt-column";
import ChatInput from "../app-chat-write-message/ChatInput";
import WarningIcon from "../../components/svgs/warningIcon";
import { isValidEmail } from "../../util";
import { withTranslation } from "react-i18next";

export const resizeScroller = () => {
  const scroller = document.getElementsByClassName('chat-message-scroller')?.[0];
  const footerHeight = (document.getElementsByClassName('app-chat-footer')?.[0])?.offsetHeight ?? 16;
  if (scroller) {
    scroller.style.height = `calc(100vh - ${scroller.getBoundingClientRect().top + footerHeight}px)`;
  }
}

class AppChat extends React.Component {
  state = {
    clients: [],
    currentSupplier: {},
    currentClient: {},
    totalFilesClient: [],
    totalFilesUser: [],
    messages: []
  };
  elColumnOverflow;
  elMessages;
  elColumnUploads;
  elAppChatWriteMessage;
  elAppChatFileUploads;
  elAppHeadsup;

  element;

  messages = this.props.messages;
  currentSupplier = this.props.currentSupplier;
  currentClient = this.props.currentClient;
  clients = this.props.clients;
  totalFilesClient = this.props.totalFilesClient;
  totalFilesUser = this.props.totalFilesUser;
  baseURL = this.props.baseURL;
  role = this.props.role;
  newMessage = [];
  chatOnly;
  notReadMessageCounter;

  componentDidMount() {
    resizeScroller();
  }

  componentDidUpdate() {
    resizeScroller();
  }

  componentHasHeight(el) {
    return new Promise((_resolve) => {
      let timeout = () => {
        setTimeout(() => {
          if (el.offsetHeight > 1) {
            _resolve();
          } else {
            timeout();
          }
        }, 0);
      };
      timeout();
    });
  }

  handleHeadsup() {
    var newMessages = this.elMessages.querySelectorAll(".new-message");
    var found = 0;
    newMessages.forEach(el => {
      // Check if message is in viewport
      if (!this.isInViewport(el)) {
        found++;
      } else {
        el.classList.remove("new-message");
      }
    });
    this.notReadMessageCounter = found;
  }

  isInViewport = elem => {
    var bounding = elem.getBoundingClientRect();
    var itemTop = bounding.top - this.elColumnUploads.getBoundingClientRect().top;
    var viewportHeight = this.elMessages.getBoundingClientRect().height;
    return (
      itemTop >= -10 &&
      (itemTop < viewportHeight / 2 ||
        itemTop + (bounding.height - 40) <= viewportHeight)
    );
  };

  sendMessage(data, animateScroll) {
    var func = () => {
      this.props.currentClient.hasConversation = true;
      let userAvatarUrl = this.props.messages.find((msg)=> (data.type === "user") && (msg.email === data.email));
      data.avatarUrl = userAvatarUrl ? userAvatarUrl.avatarUrl : data.avatarUrl;
      this.props.messages.unshift(data);
      this.setState({
        clients: [...this.props.clients]
      });

      if (data.type == "client") {
        this.setState({
          totalFilesClient: [...this.props.totalFilesClient, ...data.files]
        });
      } else {
        this.setState({
          totalFilesUser: [...this.props.totalFilesUser, ...data.files]
        });
      }
    };

    if (animateScroll) {
      this.scrollTop(func);
    } else {
      func();
    }
  }

  scrollTop(func) {
    var scrollYpos = this.elMessages.scrollTop;
    var duration = 1000;
    var delay = 0;
    if (scrollYpos <= 0) {
      duration = 0;
      delay = 0;
    } else if (scrollYpos < 200) {
      duration = 300;
    }
    var obj = {
      targets: this.elMessages,
      scrollTop: 0,
      duration: duration,
      delay: delay,
      easing: "easeInOutCubic",
      complete: func
    };
    if (!func || func instanceof Event) {
      delete obj.complete;
    }
  }

  async elWriteMessageSubmit(data) {
    if (data.message == "" && _.isEmpty(data.files)) return;
    var today = new Date();
    const messageObj = {};
    messageObj.message = data.message;
    messageObj.name = appState.state.token.name;
    messageObj.email = appState.state.token.email;
    messageObj.phone = appState.state.token.phone;
    messageObj.type = "user";
    messageObj.date = moment();
    messageObj.timestamp = today.getFullYear() + "-" + today.getMonth() + "-" + today.getDay();
    messageObj.files = data.files.map(x => ({
      mimeType: x.mimeType,
      date: moment(),
      file: x.name
    }));
    const response = await ServiceProjects.postAdminMessage(
      this.props.currentProjectId,
      this.props.currentSupplier._id,
      this.props.currentClient._id,
      data.message,
      data.files,
      this.props.areaId
    );
    messageObj.files = response.result.attachment.map((file) => {
      file.date = moment();
      file.user = {email: appState.state.token.email, name: appState.state.token.name}
      return file;
    }); // Get updated filenames from azure blob store
    messageObj.message = response.result.message;
    messageObj.avatarUrl = appState.state.token.avatarUrl;
    this.sendMessage(messageObj);
  }

  async elWriteSupplierMessageSubmit(data) {
    if (data.message == "" && _.isEmpty(data.files)) return;
    var today = new Date();
    const messageObj = {};

    messageObj.message = data.message;
    messageObj.name = this.props.currentClient.name;
    messageObj.email = this.props.currentClient.email;
    messageObj.phone = this.props.currentClient.phone;
    messageObj.type = "client";
    messageObj.date = moment();
    messageObj.timestamp =
      today.getFullYear() + "-" + today.getMonth() + "-" + today.getDay();

    const response = await ServiceProjects.postSupplierMessage(
      this.props.currentProjectId,
      this.props.currentSupplier._id,
      this.props.currentClient._id,
      data.message,
      data.files,
      this.props.areaId
    );
    messageObj.files = response.result.attachment;
    messageObj.message = response.result.message;
    this.sendMessage(messageObj);
  }

  getErrorMessage() {
    if (!this.props.currentClient.isActive) {
      return this.props.t('errorMessage.inactiveContact', 'Kontaktpersonen är borttagen från leverantören. Det går inte att skicka fler meddelanden till borttagna personer.');
    }
    if (!isValidEmail(this.props.currentClient.email) && !appState.isSupplierRole()) {
      return this.props.t('errorMessage.invalidContact', 'Kontaktpersonen har en ogiltig e-postadress. Det går inte att skicka fler meddelanden.');
    }
    return '';
  }

  render() {
    const isQuoteScreen = window.location.pathname.includes("/quotation/info");
    const errorMessage = this.getErrorMessage();
    return (
      <div className="app-chat">
        <div ref={el => (this.elAppHeadsup = el)}>
          <AppHeadsup
            onClick={this.scrollTop.bind(this)}
            count={this.notReadMessageCounter}
          />
        </div>
        <BtGrid
          id="chat-msg-cn-wrapper"
          className={`chat-msg-cn-wrapper ${
            this.props.role === appEnum.Role.Supplier ? "only--supplier" : ""
          }`}
        >
          {!this.chatOnly && this.props.role != "supplier" && (
            <BtRow
              className={`bt-contract app-chat-header ${
                this.chatOnly ? "chat-only" : ""
              }`}
            >

              <BtColumn>
                <AppChatHeaderClients
                  role={this.props.role}
                  adminUser={this.props.adminUser}
                  clients={this.props.clients}
                  baseURL={this.props.baseURL}
                  notification={this.props.notification}
                  resizeScroller={resizeScroller}
                />
              </BtColumn>
              <BtColumn className="bt-contract bt-vcenter">
                <div className="company-name">
                  <span>{this.props.currentSupplier.name}</span>
                </div>
              </BtColumn>
            </BtRow>
          )}
          {this.props.role == "supplier" &&
            <div className={styles.supplierHeaderRow}>
              <h2>{this.props.t('heading', 'Kontakta beställare')}</h2>
              <h3>{this.props.currentSupplier.name}</h3>
            </div>
          }
          <BtRow className="chat-message-window">
            <div
              className={`custom-scrollbar chat-message-scroller ${isQuoteScreen ? "style--2" : ""}`}
              ref={el => (this.elMessages = el)}
            >
              <AppChatMessages
                currentClient={this.props.currentClient}
                scope={FileScope.ProjectConversation}
                scopeOptions={{
                  projectId: this.props.currentProjectId,
                  supplierId: this.props.currentSupplier._id,
                  areaId: this.props.areaId,
                  clientId: this.props.currentClient._id,
                }}
                messages={_.isEmpty(this.state.messages) ? this.props.messages : this.state.messages}
                class="messages"
                loading={this.props.loading}
              ></AppChatMessages>
            </div>
            <BtColumn
              className="bt-contract column-uploads uploads-gallery-wrapper"
              id="uploads-gallery-wrapper"
              ref={el => (this.elColumnUploads = el)}
            >
              <AppChatFileUploads
                nameUser={`${this.props.adminUser.name}`}
                nameClient={`${this.props.currentClient.name}`}
                scope={FileScope.ProjectConversation}
                scopeOptions={{
                  projectId: this.props.currentProjectId,
                  supplierId: this.props.currentSupplier._id,
                  areaId: this.props.areaId,
                  clientId: this.props.currentClient._id,
                }}
                filesClient={_.isEmpty(this.state.totalFilesClient) ? this.props.totalFilesClient : this.state.totalFilesClient}
                filesUser={_.isEmpty(this.state.totalFilesUser) ? this.props.totalFilesUser : this.state.totalFilesUser}
                ref={el => (this.elAppChatFileUploads = el)}
              />
            </BtColumn>
          </BtRow>
          {this.props.currentClient.email && !appState.isReadOnlyAccessRole() && (
            (!errorMessage) ? (
              <BtRow className="bt-contract app-chat-footer">
                <BtColumn>
                  <ChatInput
                    onSubmit={(
                      this.props.role !== appEnum.Role.Supplier
                        ? this.elWriteMessageSubmit.bind(this)
                        : this.elWriteSupplierMessageSubmit.bind(this)
                    )}
                    resizeScroller={resizeScroller}
                  />
                </BtColumn>
              </BtRow>
            ) : (
              <BtRow className="bt-contract app-chat-footer">
                <div className="deletedSupplierContactMessage">
                  <WarningIcon color="var(--yellow-400)" />
                  {errorMessage}
                </div>
              </BtRow>
            ))}
        </BtGrid>
      </div>
    );
  }
}

export default withTranslation('projects', { keyPrefix: 'chat', withRef: true })(AppChat);
